var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 19H5V14M14 5H19V10","stroke":"#0A2240","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Expand.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
